import React, { useState } from "react";
import { Row, Col, Button, Form, Table } from "react-bootstrap";
import GoalsTable from "client_config/GoalsTable";
import ConfigureGoalsModal from "client_config/ConfigureGoalsModal";
import allMetrics from "data/allMetrics.js";
const allMetricData = allMetrics();
import jsDig from "utils/jsDig";
import { snakeCase, cloneDeep } from "lodash";
import CustomDropdown from "utils/CustomDropdown";
import CustomFormCheck from "utils/CustomFormCheck";

export default function Goals(props) {
  const metricList = allMetricData.metricsByDashboard.seo.metrics.goalsAndProjections;
  const [goalChangePercent, setGoalChangePercent] = useState(0);
  const startDate = moment("2018-01-01");
  const todaysDate = moment();
  const endDate = todaysDate.add(1, "year");
  const yearsDiff = Math.ceil(endDate.diff(startDate, "years", true));
  const yearsArray = [...Array(yearsDiff)].map((empty, index) => startDate.year() + index).reverse();
  const [allOrBlank, setAllOrBlank] = useState("blank");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let calculatorLarge = require("images/icons/calculator-large.png");
  calculatorLarge = <img src={`/datapulse${calculatorLarge}`} />;

  // Default dashboard to configure is the overall dashboard which will directly update the seo_section's goals. If there is valid id passed through parameters the controller will update the relevant LP group.
  const dashboardsInitial = [
    { name: "SEO: Overall", id: 0, goals: props.seo_section.goals },
    ...props.seo_section.landing_page_groups.map((group) => ({ name: group.name, id: group.id, goals: group.goals })),
  ];

  const [dashboards, setDashboards] = useState(dashboardsInitial);
  const [selectedDashboardId, setSelectedDashboardId] = useState(dashboards[0].id);
  const [selectedYear, setSelectedYear] = useState(moment().year().toString());
  const [selectedDashboard, setSelectedDashboard] = useState(dashboards[0].name);

  let savedCheckedMetrics = {};
  dashboards.forEach((dashboard) => {
    savedCheckedMetrics[dashboard.id] = {};
    yearsArray.forEach((year) => {
      // Get a list of which metrics have been saved to the dashboard's goals
      const goals = jsDig(["goals", year, "Jan"], dashboard);
      savedCheckedMetrics[dashboard.id][year] = goals ? Object.keys(goals).map((metricName) => metricName) : [];
    });
  });
  const [checkedMetrics, setCheckedMetrics] = useState(savedCheckedMetrics);

  const handleMetricCheck = (id, year, metricName, check) => {
    let newDashboards = dashboards;
    let newCheckedMetrics = cloneDeep(checkedMetrics);
    if (check && jsDig([id, year], newCheckedMetrics)) {
      newCheckedMetrics[id][year].push(metricName);
    } else {
      newCheckedMetrics[id][year].splice(newCheckedMetrics[id][year].indexOf(metricName), 1);
    }

    const dashIndex = newDashboards.findIndex((el) => el.id == id);
    if (!newDashboards[dashIndex].goals[year]) newDashboards[dashIndex].goals[year] = {};
    if (check == true) {
      months.forEach((month) => {
        if (!newDashboards[dashIndex].goals[year][month]) newDashboards[dashIndex].goals[year][month] = {};
        newDashboards[dashIndex].goals[year][month][metricName] = "";
      });
    } else {
      months.forEach((month) => {
        delete newDashboards[dashIndex]["goals"][year][month][metricName];
      })
    }

    setDashboards(newDashboards);
    setCheckedMetrics(newCheckedMetrics);
  };

  const handlePullMetric = (selectedId) => {
    if (props.seo_cc_data[selectedId]) {
      const year = moment().year();
      const percentChange = goalChangePercent / 100;
      // The cc data sent by the controller includes all platforms, so filter to only 'all'
      const allCcData = props.seo_cc_data[selectedId].filter((datum) => datum.platform == "all");
      let newDashboards = dashboards;
      const dashIndex = newDashboards.findIndex((el) => el.id == selectedId);
      // Reformat cc data to make it easier to access
      const ccData = {};
      allCcData.forEach((datum) => {
        let newDate = moment(datum.date.split("T")[0]);

        const newMonth = newDate.format("MMM");
        const newyear = newDate.format("YYYY");
        if (!ccData[newyear]) ccData[newyear] = {};
        ccData[newyear][newMonth] = datum;
      });

      // Only apply the changes to the metrics that have been checked
      const goalShortcutMetrics = $('.metric-selector input[type="checkbox"]:checked');
      
      months.forEach((month) => {
        goalShortcutMetrics.each((i, metricCheckbox) => {
          const metricCamel = metricCheckbox.name;
          const metricSnake = snakeCase(metricCamel);
          const historical = jsDig([year - 1, month, metricSnake, "projected"], ccData);
          const newValue = Math.round(historical * (1 + percentChange)  * 100) / 100;
          if (allOrBlank == "blank") {
            if (historical && newDashboards[dashIndex].goals[year][month][metricCamel] == "") {
              newDashboards[dashIndex].goals[year][month][metricCamel] = newValue;
            }
          } else {
            if (historical) {
              newDashboards[dashIndex].goals[year][month][metricCamel] = newValue;
            }
          }
        });
      });
      setDashboards([...newDashboards]);
    } else {
      console.log("No historical data!");
    }
  };

  return (
    <>
      <div className="seo-config-tab-content p-3" style={{ backgroundColor: "#EEEEEE" }}>
        <Row className="pl-0 pl-md-5 pt-4">
          <Col>
            <p className="f18 visby-bold text-success">Goals:</p>
          </Col>
        </Row>
        <Row className="pl-0 pl-md-5" style={{ paddingTop: "25px", gap: "20px" }}>
          <Col xl={"auto"}>
            <div className="pb-4">
              <div className="ml-0">
                <Table>
                  <tbody>
                    <tr>
                      <td className="pl-0 text-left">For:</td>
                      <td className="pt-4">
                         <CustomDropdown platformName="Seo" section="Goals" dashboards={dashboards} selectedDashboard={selectedDashboard} setSelectedDashboard={setSelectedDashboard} selectedDashboardId={selectedDashboardId} setSelectedDashboardId={setSelectedDashboardId} />
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 text-left">Year:</td>
                      <td>
                        <Form.Control
                          className="primary"
                          as="select"
                          defaultValue={selectedYear}
                          onChange={(e) => {
                            setSelectedYear(e.target.value);
                          }}>
                          {yearsArray.map((year) => {
                            return <option key={year}>{year}</option>;
                          })}
                        </Form.Control>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              
              {/* Only show the pull metrics button if the selectedYear matches the current year */}
              { selectedYear == moment().year().toString() ? (
                <>
                  { props.seo_cc_data[selectedDashboardId].length > 0 ? (
                    <div style={{ marginLeft: "2px" }} className="pt-4 text-center text-md-left goal-shortcuts">
                      <p className="pb-1 f14 nunito-regular light-primary text-left">
                        You have the option to pull in historical data from the last year to help set this year's goals. Enter a percentage change to apply to the previous year's data:
                      </p>
                      <p className="pb-2 f14 nunito-regular light-primary text-left">
                        (Negative numbers are also supported)
                      </p>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "12px", maxWidth: "100px", position: "relative"}}>
                        <Form.Control
                          className="primary"
                          size="sm"
                          as="input"
                          type="number"
                          style={{ paddingLeft: "20px" }}
                          value={goalChangePercent}
                          onChange={(e) => setGoalChangePercent(e.target.value)}
                        >
                        </Form.Control>
                        <span style={{ position: "absolute", right: "10px", top: "4px" }}>%</span>
                      </div>

                      <div className="metric-selector text-left" style={{marginTop: "12px", display: "flex", flexDirection: "column"}}>
                        <p style={{fontWeight: "bold", width: "100%", marginBottom: "2px"}}>Metrics to fill in:</p>
                        {/* Let the user select which metric to apply the change to. Generate a checkbox for each metric */}
                        {checkedMetrics[selectedDashboardId][selectedYear].map((metricName, index) => {
                          const metric = metricList[metricName];
                          return (
                            <div key={index} className="metric-checkbox" style={{marginRight: "12px"}}>
                              <CustomFormCheck
                                id={`goal-shortcut-${metricName}`}
                                label={metric.name.shortened}
                                name={metricName}
                                static
                              />
                            </div>
                          );
                        })}
                      </div>

                      <div className="all-or-blank text-left" style={{marginTop: "12px", display: "flex", flexDirection: "column"}}>
                        <p style={{fontWeight: "bold", width: "100%", marginBottom: "12px"}}>Goals to replace:</p>
                        <Form.Control
                          className="primary"
                          size="sm"
                          as="select"
                          style={{ paddingLeft: "20px" }}
                          value={allOrBlank}
                          onChange={(e) => setAllOrBlank(e.target.value)}>
                          <option value={"blank"}>Only blank fields</option>
                          <option value={"all"}>All fields</option>
                        </Form.Control>
                      </div>

                      <Button
                        style={{ paddingLeft: "45px", paddingRight: "45px" }}
                        variant="success"
                        size="sm"
                        className="mt-3"
                        onClick={() => handlePullMetric(selectedDashboardId)}>
                        Pull metrics
                      </Button>
                    </div>
                  ) : (
                    <p>No historical data has been pulled so goals cannot be generated.</p>
                  )}
                </>
              ) : <> </> }
            </div>
          </Col>
          <Col className="" xl={4} lg={"auto"}>
            <div className="px-1 text-center text-md-left">
              <p className="pb-2 px text-left">Configure which metrics for the selected for/year fields that you would like to set goals for:</p>
              <ConfigureGoalsModal
                service="seo"
                selectedDashboard={selectedDashboard} 
                setSelectedDashboard={setSelectedDashboard}
                dashboards={dashboards}
                setDashboards={setDashboards}
                selectedDashboardId={selectedDashboardId}
                setSelectedDashboardId={setSelectedDashboardId}
                handleMetricCheck={handleMetricCheck}
                checkedMetrics={checkedMetrics[selectedDashboardId][selectedYear]}
                selectedYear={selectedYear}
                metricList={metricList}
                accountType={props.client_account.account_type}
                setCheckedMetrics={setCheckedMetrics}
              />
            </div>
          </Col>
        </Row>
        <Row className="mb-5 pl-0 pl-md-4" style={{ paddingTop: "25px"}}>
          <Col>
            {dashboards.map((dashboard, dbIndex) => {
              return (
                <React.Fragment key={dbIndex}>
                  {yearsArray.map((year, yearIndex) => {
                    let visible = dashboard.id == selectedDashboardId && selectedYear == year;
                    return (
                      <div style={{ display: visible ? "block" : "none" }} key={yearIndex}>
                        <GoalsTable
                          service="seo"
                          dashboards={dashboards}
                          setDashboards={setDashboards}
                          dashboard={dashboard}
                          index={dbIndex}
                          year={year}
                          checkedMetrics={checkedMetrics[dashboard.id][year]}
                          metricList={metricList}
                        />
                      </div>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </Col>
        </Row>
      </div>
    </>
  );
}
